export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/bruno-abatti-80954654631af8ffb5ef4453a9caa3ec.jpg";